import {
	HttpErrorResponse,
	HttpEvent,
	HttpHandler,
	HttpHeaderResponse,
	HttpInterceptor,
	HttpProgressEvent,
	HttpRequest,
	HttpResponse,
	HttpSentEvent,
	HttpUserEvent,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ApiAdminInterface } from '@reach/interfaces/api-admin/api-admin.types';
import { ErrorCodes } from '@reach/interfaces/error/error-codes.enum';

import { isReachError } from '~app-client/api/utils';
import { ApiNotReachableService } from '~app-client/api-not-reachable/services';
import { CLIENT_ENVIRONMENT } from '~app-client/core/tokens';

@Injectable({ providedIn: 'root' })
export class ApiNotReachableInterceptor implements HttpInterceptor {
	private readonly apiNotReachableService = inject(ApiNotReachableService);
	private readonly environment = inject(CLIENT_ENVIRONMENT);

	intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		if (!req.url.startsWith(this.environment.apiBaseUrl)) {
			return next.handle(req);
		}

		return next.handle(req).pipe(
			tap({
				next: (event) => {
					this.handleEvent(event);
				},
				error: (event) => {
					this.handleEvent(event);
				},
			})
		);
	}

	private handleEvent(
		event:
			| HttpSentEvent
			| HttpHeaderResponse
			| HttpProgressEvent
			| HttpResponse<unknown>
			| HttpUserEvent<unknown>
	): void {
		if (
			event instanceof HttpErrorResponse &&
			isReachError(event.error) &&
			event.error.code === ErrorCodes.MIDDLEWARE_REQUESTS_NOT_ALLOWED
		) {
			this.apiNotReachableService.navigate(event.error.meta?.status as ApiAdminInterface);
		}
	}
}
